export enum DoorSortMode {
  Indeterminate,
  Price,
  Quality,
  Rating,
  Bestseller,
}